import type { LucideIcon } from 'lucide-react';
import type { ReactNode } from 'react';

interface Props {
  icon: LucideIcon;
  title: string;
  description: string;
  action?: ReactNode;
  tone?: 'neutral' | 'crit';
}

export function EmptyState({ icon: Icon, title, description, action, tone = 'neutral' }: Props) {
  return (
    <div className="flex flex-col items-center justify-center px-6 py-16 text-center">
      <div
        className={`mb-4 grid size-11 place-items-center rounded-lg border ${
          tone === 'crit'
            ? 'border-crit/30 bg-crit-soft text-crit'
            : 'border-line bg-surface-raised text-fg-muted'
        }`}
      >
        <Icon aria-hidden="true" className="size-5" strokeWidth={1.75} />
      </div>
      <h2 className="text-sm font-semibold text-fg">{title}</h2>
      <p className="mt-1 max-w-sm text-[13px] leading-relaxed text-fg-muted">{description}</p>
      {action && <div className="mt-5">{action}</div>}
    </div>
  );
}
